<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar></navbar>
			<!--导航-->
			<!--块1-->
			<div v-if="infoData" class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_1_1">
					<div class="tips_box">
						<span>Home&nbsp;&nbsp;>&nbsp;&nbsp;Products&nbsp;&nbsp;>&nbsp;&nbsp;{{ infoData.parent_name }}&nbsp;&nbsp;>&nbsp;&nbsp;</span>{{ infoData.title }}
					</div>
					<div class="tit">{{ infoData.title }}</div>
					<div class="txt" v-html="infoData.content"></div>
					<div v-if="infoData.cert_image.length > 0" class="rz_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div v-for="(value, index) in infoData.cert_image" :key="index">
							<img :src="value.image" />
						</div>
					</div>
					<div class="btn_box_ty btn_box" @click="goContact">
						Request Information<img src="../../assets/img_h5/组 32@2x.png" />
					</div>
					<div v-if="infoData.buy_url" class="btn_box_ty btn_box_ty2 btn_box" @click="goBuyNow">
						<img src="../../assets/img_h5/20230923.png" />Buy Now
					</div>
				</div>
				<div class="img_box">
					<img :src="infoData.url" @click="showBigImg" />
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<template v-if="infoData">
				<div v-if="infoData.tags.length > 0" class="block_2"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="list_box">
						<div v-for="(value, index) in infoData.tags" :key="index"
							class="list_el"
							:class="nowList == value.id ? 'actived' : ''"
							@click="listClick(value)"
						>{{ value.catname }}</div>
					</div>
					<div class="content" v-html="nowContent"></div>
				</div>
			</template>
			<!--块2-->
			<!--块3-->
			<template v-if="infoData">
				<div v-if="infoData.videos.length > 0" class="block_3"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div v-for="(value, index) in infoData.videos" :key="index" class="block_3_el">
						<div class="tit">{{ value.catname }}</div>
						<div class="video_box">
							<iframe
								width="100%"
								height="100%"
								:src="value.url"
								title="YouTube video player"
								frameborder="0"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
								allowfullscreen
							></iframe>
						</div>
						<div class="content">
							<div class="content_main" v-html="value.content"></div>
						</div>
					</div>
				</div>
				<div v-else style="padding-bottom: 50px;"></div>
			</template>
			<!--块3-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/nav.vue'  //导航组件
import footerBox from '@/component/footer.vue'  //版权组件
import fixed from '@/component/fixed.vue'  //联系我们悬浮
import { productInfo, productCount  } from '@/api/public_h5';
import md5 from 'js-md5';
import { ImagePreview } from 'vant';  //图片放大
import moment from 'moment';
export default {
	components:{
		navbar,
		footerBox,
		fixed,
	},
	metaInfo() {
		return {
			meta: [
				{
					name: "description",
					content: this.metaDescription,
				},{
					name: "keywords",
					content: this.metaKeywords,
				}
			]
		}
	},
	data() {
		return {
			isLoading: true,  //界面loading
			infoData: null,
			nowList: null,
			nowContent: '',
			imgBig: [],
			metaDescription: '',
			metaKeywords: '',
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);//请求产品信息
		productInfo({
			//id: that.$route.query.id,
			custom: that.$route.params.productInfoId,
		}).then(res => {
			that.infoData = res.data;
			document.title = res.data.title + ' - CorDx';
			that.metaDescription = res.data.description;
			that.metaKeywords = res.data.keywords;
			//设置OG标签
			that.setOgTag('og:locale', 'en_US');
			that.setOgTag('og:title', res.data.title);
			that.setOgTag('og:description', res.data.description);
			that.setOgTag('og:image', res.data.url);
			that.setOgTag('og:image:width', '1200');
			that.setOgTag('og:image:height', '630');
			that.setOgTag('og:image:type', 'webp');
			if(that.infoData.tags.length > 0) {
				that.nowList = that.infoData.tags[0].id;
				that.nowContent = that.infoData.tags[0].content;
			}
			if(that.infoData.tags.length > 0) {
				that.nowList = that.infoData.tags[0].id;
				that.nowContent = that.infoData.tags[0].content;
			}
			that.imgBig.push(that.infoData.url);
			that.isLoading = false;
			//统计访问
			let time = String(moment(new Date()).valueOf());
			setTimeout(() => {
				productCount({
					language: sessionStorage.getItem('lang') == 'en' ? 2 : 1,
					cate_id: that.infoData.cate_id,
					cert_id: that.infoData.cert_id,
					productid: that.infoData.id,
					url: that.$route.name,
					addtime: time,
					sign: md5(String(that.infoData.cate_id) + String(that.infoData.cert_id) + String(that.infoData.id) + that.$route.name + String(time) + 'CorDx2023'),
				}).then(res2 => {});
			}, 10000);
		});
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//设置OG标签
		setOgTag(property, content) {
			const meta = document.querySelector(`meta[property='${property}']`);
			if(meta) {
				meta.setAttribute('content', content);
			} else {
				const newMeta = document.createElement('meta');
				newMeta.setAttribute('property', property);
				newMeta.setAttribute('content', content);
				document.head.appendChild(newMeta);
			}
		},
		//底部列表点击
		listClick(value) {
			let that = this;
			that.nowList = value.id;
			that.nowContent = value.content;
		},
		//联系我们
		goContact() {
			this.$router.push({ path: '/contact', });
		},
		//查看大图
		showBigImg() {
			let that = this;
			ImagePreview({
				closeable: true,
				showIndicators: false,  //轮播指示器
				showIndex: false,
				images: that.imgBig,
				startPosition: 0,
			});
		},
		goBuyNow() {
			let that = this;
			window.location.href = that.infoData.buy_url;
		},
	}
}
</script>
<style scoped>
>>> .main_box ol,>>> .main_box ul{
	list-style: initial !important;
	margin: revert !important;
	padding: revert !important;
}
</style>
<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	/*块3*/
	.block_3{
		width: 100%;
		margin: 0 auto;
		padding: 0px 20px 20px 20px;
		.block_3_el:last-child{
			.content{
				border: none;
			}
		}
		.block_3_el{
			width: 100%;
			padding-top: 40px;
			.content{
				padding: 30px 0;
				border-bottom: 1px solid #CBD6E2;
			}
			.tit{
				padding-bottom: 24px;
				text-align: center;
				font-size: 22px;
				color: #000000;
			}
			.video_box{
				width: auto;
				padding-bottom: 56.25%;
				text-align: center;
				position: relative;
				iframe{
					position: absolute;
					height: 100%;
					left: 0;
					top: 0;
					width: 100%;
				}
			}
		}
	}
	/*块2*/
	.block_2{
		padding: 0px 20px;
		.content{
			padding: 0 20px;
			border: 1px solid #0B318F;
		}
		.list_box{
			.list_el{
				display: inline-block;
				margin: 0 10px 20px 0;
				padding: 10px 20px;
				font-size: 18px;
				background-color: #EFEFEF;
				color: #000000;
				cursor: pointer;
			}
			.list_el.actived{
				color: #ffffff;
				background-color: #0B318F;
			}
		}
	}
	/*块1*/
	.block_1{
		.img_box{
			margin: 42px 20px 20px 20px;
			img{ width: 100%; }
		}
		.block_1_1{
			padding: 58px 20px 20px 20px;
			background: linear-gradient(to right, #F2F7FD, transparent);
			.rz_box{
				display: flex;
				align-items: center;
				padding: 20px 0 42px 0;
				div{
					width: 64px;
					margin-right: 30px;
					img{
						width: 100%;
					}
				}
			}
			.tit{
				padding: 50px 0 8px 0;
				font-size: 30px;
			}
			.tips_box{
				font-size: 16px;
				span{
					font-size: 16px;
					color: #0B318F;
				}
			}
		}
	}
	.btn_box_ty2{
		margin-top: 12px;
		color: #E35B00;
		border: 1px solid #E37900;
		img{
			left: 0;
			margin-right: 8px;
		}
	}
}
</style>
